import { FormInput, InfoBox } from 'components/molecules';
import { TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { Form, Formik, FormikConfig } from 'formik';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { IAuthUserFormValues } from 'services/auth/types';
import { II18nextPrefix } from 'types/components/components.interface';
import { object, ref, string } from 'yup';
import { IFormikProps, IFormProps } from '../types';

const validationSchema = object().shape({
  userName: string().required(() => i18next.t('formik-error.required')),
  email: string()
    .email(() => i18next.t('formik-error.invalid-email'))
    .required(() => i18next.t('formik-error.required')),
  firstName: string().required(i18next.t('formik-error.required')),
  lastName: string().required(i18next.t('formik-error.required')),
  password: string()
    .required(i18next.t('formik-error.required'))
    .min(12, i18next.t('formik-error.password-min-length'))
    .matches(/[A-Z]/, i18next.t('formik-error.password-uppercase'))
    .matches(/[0-9]/, i18next.t('formik-error.password-number'))
    .matches(
      /[^a-zA-Z0-9]/,
      i18next.t('formik-error.password-non-alphanumeric')
    ),
  passwordConfirm: string()
    .required(i18next.t('formik-error.required'))
    .oneOf([ref('password')], i18next.t('formik-error.unmatch-password')),
});

export const authUserFormInitialValues: IAuthUserFormValues = {
  email: '',
  password: '',
  passwordConfirm: '',
  userName: '',
  firstName: '',
  lastName: '',
};

export interface IAuthUserForm
  extends FormikConfig<IAuthUserFormValues>,
    IFormProps,
    II18nextPrefix {}

const AuthUserForm = ({
  topbarContent,
  tittle,
  customBackItem,
  initialValues,
  ...props
}: IAuthUserForm) => {
  const { t } = useTranslation();

  return (
    <Formik
      {...props}
      validationSchema={validationSchema}
      validateOnChange
      validateOnBlur
      enableReinitialize
      initialValues={initialValues}>
      {({ status }: IFormikProps<IAuthUserFormValues>) => (
        <Form className='w-full h-full'>
          <TopbarPage
            topbar={
              <TopBar
                title={tittle}
                customBackItem={customBackItem}
                topbarContent={topbarContent}>
                <InfoBox loading={status?.isLoading}>
                  <InfoBox.Items columns={2}>
                    <FormInput.Text
                      name='userName'
                      label={t('input.label.nickname')}
                      autoFocus
                    />
                    <FormInput.Text
                      name='firstName'
                      label={t('input.label.firstName')}
                    />
                    <FormInput.Text
                      name='lastName'
                      label={t('input.label.lastName')}
                    />
                    <FormInput.Text
                      name='email'
                      label={t('input.label.email')}
                    />
                    <FormInput.Password
                      name='password'
                      label={t('input.label.password')}
                    />
                    <FormInput.Password
                      name='passwordConfirm'
                      label={t('input.label.confirm-password')}
                    />
                  </InfoBox.Items>
                </InfoBox>
              </TopBar>
            }
          />
        </Form>
      )}
    </Formik>
  );
};

export default AuthUserForm;
